import React from 'react';
import { noop } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store';
import { composeLocationText } from '../../../utils/formatters';

export const _SuggestedResultsDropDown = ({
  moreResults,
  setLocationText,
  setLocationObject = noop,
  validation = noop,
  updateIsHovering,
  isEditing,
  searchQuery
}) => {

  const { locationServiceStore: { locations, didError } } = useStore();

  if (!isEditing || !searchQuery) {
    return null;
  }

  if (didError) {
    return (
      <LocationErrorMessage updateIsHovering={updateIsHovering} />
    );
  }

  if (locations === null) {
    return null;
  }

  if (locations.length === 0) {
    return (
      <div className="suggested-location-input__location-results">
        <p>No locations were found.</p>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => updateIsHovering(true)}
      onMouseLeave={() => updateIsHovering(false)}
      className="suggested-location-input__location-results"
      data-testid="suggested-location-results"
    >
      { locations && locations.map(function renderResults(result, idx) {
        const LOCATION_STRING = composeLocationText(result.zipCode, result.city, result.state);

        return (
          <p
            key={idx}
            className="suggested-location-input__location-result-text"
            onClick={() => {
              setLocationObject(result);
              setLocationText(LOCATION_STRING);
              validation(LOCATION_STRING);
            }}
          >{ LOCATION_STRING }
          </p>
        );
      }) }
      {
        moreResults && (<p className="suggested-location-input__location-more-results-text">Type more information for additional results</p>)
      }
      {
        didError && (<p className="suggested-location-input__location-more-results-text">Location search is not available at this time.  Please try your search again later.</p>)
      }
    </div>
  );

};

export const SuggestedResultsDropDown = observer(_SuggestedResultsDropDown);

function LocationErrorMessage(updateIsHovering) {
  return (
    <div
      onMouseEnter={() => updateIsHovering(true)}
      onMouseLeave={() => updateIsHovering(false)}
      className="suggested-location-input__location-results"
    >
      <p className="suggested-location-input__location-more-results-text">Location search is not available at this time.  Please try your search again later.</p>
    </div>
  );

}
